import { Component, input } from '@angular/core';
import { StoryblokDirective } from '../../../directives/storyblok.directive';
import {
  RdsAvatarModule,
  RdsButtonModule,
  RdsCarouselModule,
  RdsDividerModule,
  RdsHeaderModule,
  RdsIconsModule,
  RdsMenuModule,
  RdsSearchModule,
} from '@rds/angular-components';
import { OverlayModule } from '@angular/cdk/overlay';

import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Components } from '../../../components';
import { DynamicModule } from 'ng-dynamic-component';

@Component({
  selector: 'inexp-hero-carousel',
  imports: [
    DynamicModule,
    RdsAvatarModule,
    RdsButtonModule,
    RdsDividerModule,
    RdsHeaderModule,
    RdsIconsModule,
    RdsSearchModule,
    OverlayModule,
    RdsMenuModule,
    RdsCarouselModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    StoryblokDirective,
  ],
  templateUrl: './hero-carousel.component.html',
  styleUrl: './hero-carousel.component.scss',
})
export class HeroCarouselComponent {
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();

  content = input<any[]>([]);

  components = Components;

}
